import { Alert } from '@payaca/ambrosia';
import { FC } from 'react';
import { type DraftSendEmailSuppression } from './useDraftSendEmailSuppression';

type EmailSuppressedAlertProps = {
  entityLabel: 'estimate' | 'proposal';
  suppression: DraftSendEmailSuppression;
};

/** Renders nothing unless the recipient's email is suppressed. */
const EmailSuppressedAlert: FC<EmailSuppressedAlertProps> = (props) => {
  const { entityLabel, suppression } = props;

  if (!suppression.isSuppressed) return null;

  return (
    <Alert colour="red" iconName="alert-triangle.3" className="mb-4">
      <strong>This {entityLabel} could not be sent:</strong>
      <ul className="ml-5 list-disc">
        <li>The customer's email is blocked. Reason: {suppression.reason}</li>
      </ul>
    </Alert>
  );
};

export default EmailSuppressedAlert;
